import { useEditor } from '@/state/store'
import { PROP_FAMILY_GROUPS } from '@/components/families/catalog'
import { PROP_PRESETS_BY_FAMILY } from '@/components/families/presets'

const ICONS: Record<string, string> = {
  bed: '🛏', sofa: '🛋', chair: '🪑', table: '🍽', wardrobe: '🚪', tv: '📺',
  toilet: '🚽', sink: '🚰', shower: '🚿', kitchenCounter: '🧑‍🍳', car: '🚗', bike: '🏍',
}

/** Catalog of placeable props, grouped by category. Clicking arms the prop tool with that preset. */
export function PropPanel() {
  const activePresetId = useEditor((s) => s.activePresetId)
  const setActivePresetId = useEditor((s) => s.setActivePresetId)
  const setTool = useEditor((s) => s.setTool)
  const tool = useEditor((s) => s.tool)

  function pick(presetId: string) {
    setActivePresetId(presetId)
    setTool('prop')
  }

  return (
    <section className="panel draw-panel">
      <div className="panel-head">
        <h3>Place prop</h3>
      </div>
      {PROP_FAMILY_GROUPS.map((group) => (
        <div key={group.category} className="prop-group">
          <h4 className="prop-group-label">{group.label}</h4>
          <div className="prop-grid">
            {group.families.flatMap((family) =>
              (PROP_PRESETS_BY_FAMILY[family.id] ?? []).map((preset) => {
                const active = tool === 'prop' && activePresetId === preset.id
                return (
                  <button
                    key={preset.id}
                    className={`prop-chip${active ? ' active' : ''}`}
                    onClick={() => pick(preset.id)}
                    title={preset.label}
                  >
                    <span className="prop-icon">{ICONS[family.id] ?? '▭'}</span>
                    <span className="prop-name">{preset.label}</span>
                  </button>
                )
              })
            )}
          </div>
        </div>
      ))}
      <p className="hint-note">Pick a prop, then click on the plan to drop it. Select it (V) to move, rotate ([ / ]), or resize in the inspector.</p>
    </section>
  )
}
